import { render, staticRenderFns } from "./jingli.vue?vue&type=template&id=7a448068&scoped=true&"
import script from "./jingli.vue?vue&type=script&lang=js&"
export * from "./jingli.vue?vue&type=script&lang=js&"
import style0 from "./jingli.vue?vue&type=style&index=0&id=7a448068&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a448068",
  null
  
)

export default component.exports